import { openDB } from "idb";

const DB_NAME = "audioDB";
const STORE_NAME = "audioFiles";
const AUDIO_KEY = "userAudio";

export const initDB = async () => {
	return openDB(DB_NAME, 1, {
		upgrade(db) {
			if (!db.objectStoreNames.contains(STORE_NAME)) {
				db.createObjectStore(STORE_NAME, { keyPath: "id" });
			}
		},
	});
};

export const saveAudio = async (file: Blob) => {
	const db = await initDB();
	const tx = db.transaction(STORE_NAME, "readwrite");
	const store = tx.objectStore(STORE_NAME);
	await store.put({ id: AUDIO_KEY, data: file });
	await tx.done;
};

export const getAudio = async () => {
	const db = await initDB();
	const tx = db.transaction(STORE_NAME, "readonly");
	const store = tx.objectStore(STORE_NAME);
	const result = await store.get(AUDIO_KEY);
	return result?.data; // Returns Blob or undefined
};

export const deleteAudio = async () => {
	const db = await initDB();
	const tx = db.transaction(STORE_NAME, "readwrite");
	const store = tx.objectStore(STORE_NAME);
	await store.delete(AUDIO_KEY);
	await tx.done;
};
